import React, { Component } from "react";
import "./Sidebar.scss";
import { withRouter } from "react-router-dom";
import { User } from "react-feather";
import { getESPUser } from "../../utils/localStorage";

const DashboardItem = {
	key: "ESP_DASHBOARD",
	path: "/service_partner/dashboard",
	name: "Dashboard",
	PageTitle:"Dashboard"
};
const ESPServiceRequestContainer = {
	key: "ESP_SERVICE_REQUEST_CONTAINER",
	path: "/service_partner/service-requests",
	name: "Service Requests",
	PageTitle:"Service Requests"
};
const ESPReportsContainer = {
	key: "ESP_REPORTS_CONTAINER",
	path: "/service_partner/reports",
	name: "Reports",
	PageTitle:"Reports"
};
const UploadStatusProgressionSheetContainer = {
	key: "UPLOAD_STATUS_PROGREESION_SHEET_CONTAINER",
	path: "/service_partner/upload-status-progression-sheet",
	name: "Upload Progression Sheet",
	PageTitle:"Upload Status Progression Sheet"
};

const ESPFollowUpsContainer = {
	key: "ESP_FOLLOW_UPS_CONTAINER",
	path: "/service_partner/follow-ups",
	name: "Follow Ups",
	PageTitle:"Follow Ups"
};

const ESPSubscriberContainer = {
	key: "ESPSUBSCRIBERS_CONTAINER",
	path: "/service_partner/espsubscriber",
	name: "Prime Subscribers",
	PageTitle:"Prime Subscribers"
}

const ESPUmcServicesContainer = {
	key: "ESPUMCSERVICES_CONTAINER",
	path: "/service_partner/espumcinterface",
	name: "Bulk Services Management",
	PageTitle:"Bulk Services Management"
}

const ESPUmcReportingContainer = {
	key: "ESPUMCREPORTING_CONTAINER",
	path: "/service_partner/espumcreporting",
	name: "UMC Customers",
	PageTitle:"UMC Customers"
}

const ESPFeedbackContainer = {
	key: "ESP_CUSTOMER_FEEDBACK_CONTAINER",
	path: "/service_partner/espumcfeedback",
	name: "UMC Customer Feedbacks",
	PageTitle:"Customer Feedbacks"
};


export const SELECTED_SIDE_BAR_ITEM_KEY = "SELECTED_SIDE_BAR_ITEM";

class ESPSidebarContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			selectedItemPath: "",
			items: [],
		};
		this.unlisten = null;
	}
	componentDidMount() {
		const storageItem = localStorage.getItem(SELECTED_SIDE_BAR_ITEM_KEY);
		const user = getESPUser();
		if (!user) {
			this.props.history.push("/service_partner/login");
			return;
		}
		let items = [];
        items.push(DashboardItem);
        items.push(ESPServiceRequestContainer);
		items.push(ESPReportsContainer);
		// if(user && user.email === "skgkudyam@mailinator.com"){
		// 	items.push(ESPSubscriberContainer)
		// }
		if(user && user.email === "marketconnect@deasra.co.in"){
			items.push(ESPUmcServicesContainer)
			items.push(ESPUmcReportingContainer)
			items.push(ESPFeedbackContainer)
		}

		if (user&&user.external_partner_details&&user.external_partner_details.sServicePartnerOrg&&user.external_partner_details.sServicePartnerOrg.includes("Vakilsearch"))
		{
			items.push(UploadStatusProgressionSheetContainer);
		}
		items.push(ESPFollowUpsContainer);
		this.setState({
			selectedItemPath: storageItem || "",
			items,
		});
		// this.unlisten = this.props.history.listen((location, action) => {
		//   console.log("location change.");
		//   console.log(location.pathname);
		//   localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, location.pathname);
		//   this.setState({ selectedItemPath: location.pathname });
		// });
	}
	componentWillUnmount() {
		// if (this.unlisten) {
		//   this.unlisten();
		// }
	}
	handleItemClick = (item) => {
		this.setState({ selectedItemPath: item.path });
		localStorage.setItem(SELECTED_SIDE_BAR_ITEM_KEY, item.path);
		this.props.history.push(`${item.path}`);
		this.props.toggleSidebar();
		this.props.changePageTitle(item.PageTitle);
	};
	// handleLogout = () => {
	//   api.logout ().then(({data}) => {
	//     console.log(data)
	//     localStorage.clear();
	//     this.props.history.push('/login');
	//   })
	// }
	getDisplayName = () => {
		const user = getESPUser();
		const view = [];
		if (user) {
			if (user.external_partner_details.sName) {
				view.push(<div key={"name"}>{user.external_partner_details.sName}</div>);
			}
			if (user.external_partner_details.sServicePartnerOrg) {
				view.push(
					<div key={"email"}>
						<small>{user.external_partner_details.sServicePartnerOrg}</small>
					</div>
				);
			}
		}
		return view;
	};
	render() {
		const { selectedItemPath, items } = this.state;
		return (
			<div className="sp-sidebar">
				<div className="sp-sidebar-header">
					<User className="conv-mr15"/>
					<div className="display-name">{this.getDisplayName()}</div>
				</div>

				{items.map((item) => {
					return (
						<div
							className={`sp-sidebar-item flex align-items-center row conv-mr0 ${
								localStorage.getItem(SELECTED_SIDE_BAR_ITEM_KEY) === item.path ? "sp-sidebar-item-active" : ""
							}`}
							onClick={() => this.handleItemClick(item)}
							key={item.key}
						>
							<div className="ml-3 title">{item.name}</div>
						</div>
					);
				})}
			</div>
		);
	}
}
export default withRouter(ESPSidebarContent);